import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { BlogService } from '../../services/blog.service';
import { RouterLink } from '@angular/router';

export interface FooterCategory {
  name: string;
  blogs: { id?: number; title: string; slug: string }[];
  isOpen: boolean;
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [RouterLink, NgFor, NgIf]
})
export class FooterComponent implements OnInit {
  footerCategories: FooterCategory[] = [];

  constructor(
    private blogService: BlogService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.blogService.getPublicBlogs().subscribe({
        next: (blogs) => {
          if (blogs && blogs.length > 0) {
            // Filter to only include posts configured to show in footer
            const allowedBlogs = blogs.filter(b => b.showInFooter === true);
            const categoryMap = new Map<string, { id?: number; title: string; slug: string }[]>();

            allowedBlogs.forEach(b => {
              if (b.category) {
                const trimmed = b.category.trim();
                if (trimmed) {
                  const key = trimmed.toLowerCase();
                  if (!categoryMap.has(key)) {
                    categoryMap.set(key, []);
                  }
                  categoryMap.get(key)!.push({
                    id: b.id,
                    slug: b.slug || (b.id !== undefined ? b.id.toString() : ''),
                    title: b.title
                  });
                }
              }
            });

            const categories: FooterCategory[] = [];
            categoryMap.forEach((blogsList, key) => {
              const originalBlog = allowedBlogs.find(b => b.category && b.category.trim().toLowerCase() === key);
              const originalName = originalBlog && originalBlog.category ? originalBlog.category.trim() : key;
              categories.push({
                name: originalName,
                blogs: blogsList,
                isOpen: false
              });
            });

            this.footerCategories = categories.slice(0, 5);
          } else {
            this.footerCategories = [];
          }
        },
        error: (err) => {
          console.error('Failed to load footer categories from database', err);
          this.footerCategories = [];
        }
      });
    }
  }

  toggleCategory(category: FooterCategory, event: Event): void {
    event.preventDefault();
    const currentStatus = category.isOpen;
    this.footerCategories.forEach(c => c.isOpen = false);
    category.isOpen = !currentStatus;
  }
}
